import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	companyInfo: {
		boxSizing: 'border-box',
		padding: '20px 10px 10px 0',
	},
});
